import { useEffect, useMemo, useState } from 'react';
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { CONSTANTS } from '../../../../constants/constants';
import NRLink from '../../../NRLink/NRLink';
import { buildJiraConfigurationNavigation } from '../../../../pages/NRSettings/NRIntegrations/NRJiraIntegration/jiraIntegration.constants';
import { JIRA_STATUS_MAPPING_PROBLEM_LABELS } from '../../../../pages/NRSettings/NRIntegrations/NRJiraIntegration/jiraIntegrationDetail.constants';

const INLINE_LINK_SX = {
  width: 'auto',
  maxWidth: 'none',
  display: 'inline',
  typography: 'body2',
  textDecoration: 'underline',
  verticalAlign: 'baseline'
};

const FIX_IN_LINK_PREFIX = 'Fix in ';

function getPrimaryProblemSpace(problems = []) {
  const problemWithSpace = problems.find(problem => problem.spaceId || problem.spaceName || problem.projectKey);
  if (!problemWithSpace) {
    return { spaceId: null, spaceName: null, projectKey: null };
  }

  return {
    spaceId: problemWithSpace.spaceId || null,
    spaceName: problemWithSpace.spaceName || null,
    projectKey: problemWithSpace.projectKey || null
  };
}

function getProblemsSignature(problems = []) {
  return problems.map(problem => problem.id).join('|');
}

function NRJiraTicketStatusMappingProblemAlert({ problems = [] }) {
  const theme = useTheme();
  const navigate = useNavigate();
  const [isDismissed, setIsDismissed] = useState(false);
  const problemsSignature = useMemo(() => getProblemsSignature(problems), [problems]);
  const count = problems.length;

  useEffect(() => {
    setIsDismissed(false);
  }, [problemsSignature]);

  if (count === 0 || isDismissed) {
    return null;
  }

  const focus = getPrimaryProblemSpace(problems);
  const configurationNavigation = buildJiraConfigurationNavigation(focus);
  const linkLabel = focus.spaceName
    ? `${FIX_IN_LINK_PREFIX}${focus.spaceName}`
    : JIRA_STATUS_MAPPING_PROBLEM_LABELS.VULN_DRAWER_WARNING_LINK_FALLBACK;
  const message = JIRA_STATUS_MAPPING_PROBLEM_LABELS.VULN_DRAWER_WARNING.replace('{count}', String(count));

  return (
    <Alert
      severity="warning"
      variant="outlined"
      onClose={() => setIsDismissed(true)}
      closeText={CONSTANTS.ACTIONS.CLOSE}
    >
      <Typography variant="body2" component="span" color="text.primary" sx={{ display: 'inline' }}>
        {message}
        <NRLink
          text={linkLabel}
          showExternalIcon={false}
          color={theme.palette.text.secondary}
          sx={INLINE_LINK_SX}
          onClick={event => {
            event.preventDefault();
            navigate(configurationNavigation.pathname, { state: configurationNavigation.state });
          }}
        />
      </Typography>
    </Alert>
  );
}

export default NRJiraTicketStatusMappingProblemAlert;
